import { RecentOrFavoriteOrderMeal } from '@/models';
import { ServicesContainer } from '@/services';
import { AnalyticsEvent } from '../models';
import { AnalyticsMeal } from '../platforms/adobe-analytics/models';

export class AccountManagementEvent implements AnalyticsEvent {
  name = 'AccountManagementEvent';

  constructor(public readonly eventType: string, public readonly meals?: RecentOrFavoriteOrderMeal | RecentOrFavoriteOrderMeal[], public readonly rewardTitle?: string, public readonly siteSection?: string) {}
}
